module.exports = __webpack_public_path__ + "static/media/AB_lock_green_new.7d431a5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_lock_green_new.svg
// module id = 1063
// module chunks = 0